import React from 'react'
import './item.css'

class ItemCreate extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        var timed;
        if (this.props.timed) {
            timed = (
                <div className="item-create-timed">
                    <p className="item-create-timed-word">限制时长</p>
                    <textarea className="item-create-timed-input" placeholder="30分钟"></textarea>
                </div>
            );
        }
        return (
            <div className="item-create">
                <div className="item-create-entry">
                    <p className="item-create-entry-word">{this.props.name}名称</p>
                    <textarea className="item-create-entry-input item-create-name-input"></textarea>
                </div>
                <div className="item-create-entry">
                    <p className="item-create-entry-word">{this.props.name}说明</p>
                    <textarea className="item-create-entry-input item-create-log-input"></textarea>
                </div>
                <div className="item-create-entry">
                    <p className="item-create-entry-word">有效时间</p>
                    <textarea className="item-create-entry-input item-create-log-input1" placeholder="2020-04-13"></textarea>
                    <textarea className="item-create-entry-input item-create-log-input2" placeholder="08:30"></textarea>
                    <p className="item-create-entry-word">&ensp;至</p>
                    <textarea className="item-create-entry-input item-create-log-input3" placeholder="2020-04-15"></textarea>
                    <textarea className="item-create-entry-input item-create-log-input4" placeholder="23:30"></textarea>
                    {timed}
                    <button className="item-create-publish">发布</button>
                </div>
            </div>
        );
    }
}

export default ItemCreate;